import React from 'react';

import { Nullable } from '@clearverify/types';

import { usePermissiblePurposeReferencesListQuery, Verifier } from 'src/api';

import { getPermissiblePurposeReferenceOption } from './utils';

export const useCrediblePermissiblePurposeReferenceOptions = (
  verifier: Nullable<Pick<Verifier, 'id' | 'type'>>,
) => {
  const { data: permissiblePurposeReferenceData, loading: isPermissiblePurposeReferenceLoading } =
    usePermissiblePurposeReferencesListQuery({
      variables: {
        filter: {
          verifierType: {
            equals: verifier?.type,
          },
          permissiblePurposes: {
            every: {
              verifierId: {
                not: { equals: verifier?.id },
              },
            },
          },
        },
      },
      fetchPolicy: 'network-only',
      skip: !verifier?.id || !verifier.type,
    });

  const permissiblePurposeReferenceOptions = React.useMemo(() => {
    return (
      permissiblePurposeReferenceData?.permissiblePurposeReferenceList.map(
        getPermissiblePurposeReferenceOption,
      ) ?? []
    );
  }, [permissiblePurposeReferenceData?.permissiblePurposeReferenceList]);

  return {
    isCrediblePermissiblePurposesLoading: isPermissiblePurposeReferenceLoading,
    crediblePermissiblePurposeOptions: permissiblePurposeReferenceOptions,
  };
};
